import React, { useState, useEffect } from "react";
import api from '../../api';

// Reports tab component
export const ReportsTab = ({ reports, decks, cardTypes, users, languages, symbols = [], onEditReport, onEditCard, onEditDeck, onEditUser, onRowClick }) => {
  const [filteredReports, setFilteredReports] = useState(reports);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const reportsPerPage = 20;

  useEffect(() => {
    let result = [...reports];
    if (statusFilter !== "all") {
      result = result.filter(report => report.status === statusFilter);
    }
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter(report => 
        report.report_id?.toString().includes(searchLower) ||
        report.reason?.toLowerCase().includes(searchLower) ||
        report.reported_by_name?.toLowerCase().includes(searchLower) ||
        report.deck_name?.toLowerCase().includes(searchLower)
      );
    }
    setFilteredReports(result);
    setCurrentPage(1);
  }, [reports, statusFilter, searchTerm]);

  const indexOfLastReport = currentPage * reportsPerPage;
  const indexOfFirstReport = indexOfLastReport - reportsPerPage;
  const currentReports = filteredReports.slice(indexOfFirstReport, indexOfLastReport);
  const totalPages = Math.ceil(filteredReports.length / reportsPerPage);

  const getStatusBadge = (status) => {
    const colors = {
      open: { bg: '#ffc107', color: '#212529' },
      resolved: { bg: '#17a2b8', color: '#fff' },
      closed: { bg: '#28a745', color: '#fff' }
    };
    const { bg, color } = colors[status] || { bg: '#6c757d', color: '#fff' };
    return (
      <span style={{ 
        padding: '4px 8px', 
        borderRadius: '4px', 
        fontSize: '12px',
        fontWeight: 'bold',
        background: bg,
        color: color
      }}>
        {status}
      </span>
    );
  };

  return (
    <div>
      <h2>Reports</h2>
      
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Search by report ID, reason, user, or deck..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginRight: "10px", padding: "5px" }}
        />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ padding: "5px" }}
        >
          <option value="all">All Statuses</option>
          <option value="open">Open</option>
          <option value="resolved">Resolved</option>
          <option value="closed">Closed</option>
        </select>
      </div>

      <div style={{ marginBottom: "10px" }}>
        Showing {indexOfFirstReport + 1}-{Math.min(indexOfLastReport, filteredReports.length)} of {filteredReports.length} reports
      </div>

      <table>
        <thead>
          <tr>
            <th style={{ width: '100px' }}>Status</th>
            <th>Reason</th>
            <th style={{ width: '400px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentReports.map((report) => {
            return (
              <tr 
                key={report.report_id} 
                onClick={() => onRowClick && onRowClick('reports', report)}
                style={{ cursor: 'pointer' }}
              >
                <td style={{ textAlign: 'center' }}>
                  {getStatusBadge(report.status)}
                </td>
                <td style={{ 
                  maxWidth: 500, 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                  padding: '10px 12px'
                }}>
                  {report.reason}
                </td>
                <td style={{ textAlign: 'center', padding: '10px 12px' }}>
                  <button 
                    className="small-action-btn edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditCard && onEditCard(report);
                    }}
                    title="Edit Card"
                  >
                    Edit Card
                  </button>
                  <button 
                    className="small-action-btn edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditDeck && onEditDeck(report);
                    }}
                    title="Edit Deck"
                  >
                    Edit Deck
                  </button>
                  <button 
                    className="small-action-btn edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditUser && onEditUser(report);
                    }}
                    title="Edit User"
                  >
                    Edit User
                  </button>
                  {onEditReport && (
                    <button 
                      className="admin-nav-btn"
                      style={{ background: 'var(--primary)', color: 'white', border: 'none', textAlign: 'center', width: 'auto', padding: '0.5rem 1rem' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditReport(report);
                      }}
                    >
                      {report.status === 'open' ? 'Close' : report.status === 'resolved' ? 'Reopen' : 'Reopen'}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div style={{ marginTop: "20px" }}>
          <button
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};